module.exports = __webpack_public_path__ + "img/france.0fd10159.svg";